import React from "react";
import {
  Grid,
  TextField,
  DialogTitle,
  DialogContent,
  Divider,
  IconButton,
  Dialog,
  Chip,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomTypography from "../../globalStyles/fonts";

const CustomerDetailsModal = ({ customer, open, onClose }) => {
  if (!customer) return null;

  const field = (label, value) => (
    <Grid item xs={12} sm={6}>
      <CustomTypography fontSize={13} fontWeight={500}>
        {label}
      </CustomTypography>
      <TextField
        size="small"
        margin="dense"
        variant="outlined"
        fullWidth
        value={value || ""}
        InputProps={{ readOnly: true }}
        sx={{
          "& .MuiInputBase-input": { color: "var(--text-secondary)" },
          "& .MuiOutlinedInput-root": { backgroundColor: "var(--bg-paper)" },
        }}
      />
    </Grid>
  );

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <DialogTitle fontSize={20} fontFamily="poppins" fontWeight={500}>
          Customer Details
        </DialogTitle>
        <IconButton onClick={onClose} style={{ marginRight: 8 }}>
          <CloseIcon />
        </IconButton>
      </div>
      <Divider />
      <DialogContent>
        <Grid container spacing={2}>
          {field("Name", customer?.name)}
          {field("Email", customer?.email)}
          {field("Phone", customer?.phone)}
          {field("First Name", customer?.first_name)}
          {field("Last Name", customer?.last_name)}
          {field("Currency", customer?.currency)}
        </Grid>

        {customer?.address?.length > 0 && (
          <>
            <Divider style={{ marginTop: 16, marginBottom: 8 }} />
            <CustomTypography fontSize={14} fontWeight={600}>
              Addresses
            </CustomTypography>
            {customer.address.map((addr, idx) => (
              <Box
                key={idx}
                sx={{
                  border: "1px solid var(--border-color)",
                  borderRadius: 1,
                  p: 1.5,
                  mt: 1,
                  backgroundColor: "var(--bg-paper)",
                }}
              >
                <Grid container spacing={1}>
                  {field("Address 1", addr?.address1)}
                  {field("Address 2", addr?.address2)}
                  {field("City", addr?.city)}
                  {field("Province", addr?.province)}
                  {field("Country", addr?.country)}
                  {field("Zip", addr?.zip)}
                </Grid>
              </Box>
            ))}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default CustomerDetailsModal;
